module.exports = __webpack_public_path__ + "static/media/mastercard-logo.009d6d79.svg";